import * as svg from "../../../assets/battery-low.svg";

import {iconBuilder} from "./iconBuilder";

export const BatteryLowIcon = iconBuilder(svg, "BatteryLowIcon", "0 0 24 24");
